import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { IconEditPhoto } from '../../easyclaim.app.assets/index';
import { FadeIn } from '../animations/FadeIn';

import { Rectangle } from './Rectangle';

export function getEditIcon(onClick: () => void) {
	return (
		<TopRectangle
			size="2rem"
			backgroundColor="#eee"
			onClick={onClick}
			className="change-photo-button"
		>
			<IconEditPhotoSpan className="IconEditPhotoSpan">
				<FormattedMessage id="editPhoto.edit" />
			</IconEditPhotoSpan>
			<IconEditPhoto height="1.5rem" />
		</TopRectangle>
	);
}

export const TopRectangle = styled(Rectangle)`
	position: absolute;
	top: 1rem;
	right: 1rem;
	opacity: 0;
	padding: 0 10px 0 10px;
	animation: ${css`
			${FadeIn}`} 0.3s ease-out forwards 0.6s;
`;

const IconEditPhotoSpan = styled.span`
	margin-right: 0.3rem;
`;
